import { DataRow } from "@client/components/round/allocator/RatingTable/RatingTable";

export function exportScores(
  rows: DataRow[],
  evaluatorNames: string[],
): string {
  const header = ["", ...evaluatorNames].join("\t");

  const groupedRows = rows.reduce(
    (acc, row) => {
      if (!acc[row.orgName]) {
        acc[row.orgName] = {};
      }
      acc[row.orgName][row.evaluatorName] = row.rating;
      return acc;
    },
    {} as Record<string, Record<string, string>>,
  );

  const dataRows = Object.entries(groupedRows)
    .sort(([orgNameA], [orgNameB]) =>
      orgNameA.toLowerCase().localeCompare(orgNameB.toLowerCase()),
    )
    .map(([orgName, ratings]) => {
      const rowData = [orgName];
      evaluatorNames.forEach((evaluator) => {
        rowData.push(ratings[evaluator] || "");
      });
      return rowData.join("\t");
    });

  return [header, ...dataRows].join("\n") + "\n";
}
